import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonIcon, OpacityStyleEnum } from '@sphereon/ui-components.core';
import SSIAddIcon from '../../assets/icons/SSIAddIcon';
import { SecondaryButtonCaptionStyled as Caption, SecondaryButtonContainerStyled as Container } from '../../../styles';
import { gradientColors } from '../../../styles/colors';
const SecondaryButton = (props) => {
    const { caption, icon, onClick, style } = props;
    const disabled = typeof props.disabled === 'function' ? props.disabled() : props.disabled ?? false;
    const getIcon = (icon, color) => {
        switch (icon) {
            case ButtonIcon.ADD:
                return _jsx(SSIAddIcon, { style: { ...(disabled && { opacity: OpacityStyleEnum.DISABLED }) }, color: color });
            default:
                return _jsx("div", {});
        }
    };
    const onClicked = async () => {
        if (!disabled) {
            await onClick();
        }
    };
    return (_jsxs(Container, { style: { ...style, ...(disabled && { opacity: OpacityStyleEnum.DISABLED }) }, onClick: onClicked, children: [icon && getIcon(icon, gradientColors['100']), _jsx(Caption, { style: { ...(disabled && { opacity: OpacityStyleEnum.DISABLED }) }, children: caption })] }));
};
export default SecondaryButton;
